@if (isVisible) {
  <emoji-mart
    class="emoji-mart"
    [isNative]="true"
    [perLine]="10"
    [darkMode]="isDarkMode"
    [i18n]="emojiI18n"
    (emojiSelect)="onEmojiSelect($event)"
    [title]="'EMOJI.TITLE' | translate"
    emoji="grinning"
  ></emoji-mart>
}